window.addEventListener('DOMContentLoaded', () => {

    const searchBlock = document.querySelector('.search-block');
    const searchInput = document.querySelector('.search-block input');
    const searchForm = document.querySelector('.search-block form');
    const searchError = document.querySelector('.search-wrapper > span');
    const errormessage = searchError.dataset.errortext
    
    searchInput.addEventListener('input', (e) => {
        if(e.target.value.length >= 3){
            searchBlock.classList.add('filled');
            searchError.innerText = "";
        } else{
            searchBlock.classList.remove('filled');
            // searchError.innerText = "Ce champ doit contenir au moins 3 caractères";
        }
    })

    searchForm.addEventListener('submit', (e) => {
        if(searchInput.value.length < 3){
            e.preventDefault();
            searchError.innerText = errormessage;
        }
    })

    const btnNext = document.querySelector('.pagination-container .next a');
    const btnPrev = document.querySelector('.pagination-container .prev a');

    // if(btnNext){
    //     btnNext.innerHTML = `<span class="next">${btnNext.innerText.split('»')[0]}</span><img class="arrow-right" src="https://cdn.shopify.com/s/files/1/0602/6376/0064/files/XMLID_29_2.svg?v=1678874435" width="23" height="15" alt="bouton page suivante">`;
    // }
    // if(btnPrev){
    //     btnPrev.innerHTML = `<img class="arrow-left" src="https://cdn.shopify.com/s/files/1/0602/6376/0064/files/XMLID_29.svg?v=1678874435" width="23" height="15" alt="bouton page précedente"><span class="prev">${btnPrev.innerText.split('«')[0]}</span>`;
    // }

    

    const blogHeaderLinkMobile = document.querySelector('.mobile-nav-list a.blog_link');
   if(blogHeaderLinkMobile){
      blogHeaderLinkMobile.addEventListener('click', e => {
      e.preventDefault();
      closeHeaderMobile();
      })
   }

    function closeHeaderMobile(){
        headerMobileContainer.classList.remove('active');
        headerMobileContainer.classList.add('not-active');
        menuBtn.classList.remove('active');
        showMenu = false;
        document.body.style.height = 'auto';
        document.body.style.overflow = 'unset';
    }


$('.page a').on('click',function (e) {
  e.preventDefault();
  $('.page').removeClass('current');
  $(this).parent('.page').addClass('current');
  var lastpage = $('#lastpage').val();
  lastpage = parseInt(lastpage);
  var pageId = $(this).data('page');
  pageId = parseInt(pageId);
  if(pageId == 1){
    $('.prev').addClass('grey');
  }else{
    $('.prev').removeClass('grey');
  }
  if(pageId == lastpage){
    $('.next').addClass('grey');
  }else{
    $('.next').removeClass('grey');
  }
  $('.recent-article').addClass('hidden');
  $('.recent-article[data-pageid='+pageId+']').removeClass('hidden');
})

$('.prev a').on('click',function (e) {
  e.preventDefault();
  var pageId = $('.page.current a').data('page');
  pageId = parseInt(pageId);
  
  if(pageId == 1){}else {
    pageId = pageId - 1;
  }
  $('.page').removeClass('current');
  $('.page a[data-page="'+pageId+'"]').parent('.page').addClass('current');
  if(pageId == 1){
    $('.prev').addClass('grey');
  }
  $('.next').removeClass('grey');
  $('.recent-article').addClass('hidden');
  $('.recent-article[data-pageid='+pageId+']').removeClass('hidden');
})


$('.next a').on('click',function (e) {
  e.preventDefault();
  var pageId = $('.page.current a').data('page');
  var lastpage = $('#lastpage').val();
  lastpage = parseInt(lastpage);
  pageId = parseInt(pageId);
  if(pageId == lastpage){}else {
    pageId = pageId + 1;
  }
  $('.page').removeClass('current');
  $('.page a[data-page="'+pageId+'"]').parent('.page').addClass('current');
  if(pageId == lastpage){
    $('.next').addClass('grey');
  }
  $('.prev').removeClass('grey');
  $('.recent-article').addClass('hidden');
  $('.recent-article[data-pageid='+pageId+']').removeClass('hidden');
})
  
 $(window).on('load',function(){
   if($(this).width() < 850){
     var height = $('.recent-posts-slider').height();
     $('.recent-posts-slider').css('min-height', height);
   }
 }) 

 $(window).resize(function(){
   if($(this).width() < 850){
     setTimeout(function(){
       var height = $('.recent-posts-slider').height();
       $('.recent-posts-slider').css('min-height', height);
     }, 500)
   }
 }) 

  var reviFromLast = false;
  var reverseProcess = false;
  var dotsToShow = $('#dots_to_show').val();
  dotsToShow = parseInt(dotsToShow);
  $(document).on('click','.next-arrow-btn',function(){
    var currentIndex = $('.slick__slide.slick-active').data('slick-index');
    currentIndex = currentIndex + 1
    $('.recent-posts-slider').slick('slickGoTo', currentIndex);
    if(currentIndex%dotsToShow == 0){
      setTimeout(function(){
       var indexSum = 0;
        $('.slick-dots').find('li').each(function(index, el){
         if($(this).hasClass('slick-active')){
           var elindex = index;
           indexSum = elindex + dotsToShow;
             $(this).show();
         }else if(indexSum > index){
            $(this).show();
         }else{
           $(this).hide();
         }
        });
      },500)
    }
  })

  
  $('.recent-posts-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var slideCount = slick.slideCount;
    if(slideCount - 1 == nextSlide){
      $('.next-arrow').addClass('grey');
    }else{
      $('.next-arrow').removeClass('grey');
    }

    if(nextSlide == 0){
      $('.prev-arrow').addClass('grey');
    }else{
      $('.prev-arrow').removeClass('grey');
    }
    
  });

  $(document).on('click','.prev-arrow-btn',function(){
    var currentIndex = $('.slick__slide.slick-active').data('slick-index');
    if(reviFromLast == false && reverseProcess == false){
      currentIndex = currentIndex - 1; 
    }
    $('.recent-posts-slider').slick('slickGoTo', currentIndex);
    reviFromLast = false;
    reverseProcess = false;
    var minV = dotsToShow - 1
    if(currentIndex%dotsToShow == minV){
      var activeIndex = $('.slick-dots li.slick-active').find('button').html();
      activeIndex = parseInt(activeIndex);
      
      var nactiveIndex = parseInt(activeIndex) - dotsToShow;
      $('.slick-dots').find('li').each(function(index, el){
        if($(this).hasClass('slick-active')){
         var elindex = index;
         var minusValue = dotsToShow - 1;
         indexSum = elindex - minusValue;
         // indexSum = elindex - 3;
         $(this).show();
        }else if(nactiveIndex <= index && activeIndex > index){
          $(this).show();
        }else{
         $(this).hide();
        }
      });
    }
  })

  $('.recent-posts-slider').on('swipe', function(event, slick, direction){
    var sliderCount = slick.slideCount;
    if(direction == 'left'){
      var currentIndex = $('.slick__slide.slick-active').data('slick-index');
      if(currentIndex%dotsToShow == 0){
        var indexSum = 0;
        $('.slick-dots').find('li').each(function(index, el){
         if($(this).hasClass('slick-active')){
           var elindex = index;
           indexSum = elindex + dotsToShow;
             $(this).show();
         }else if(indexSum > index){
            $(this).show();
         }else{
           $(this).hide();
         }
        });
      }
    }else{
      var currentIndex = $('.slick__slide.slick-active').data('slick-index');
      var minV = dotsToShow - 1
      if(currentIndex%dotsToShow != 0 && sliderCount - 2 == currentIndex){
        setTimeout(function(){
          reviFromLast = true;
          $('.prev-arrow-btn').trigger('click');
        },500)
      }else if(currentIndex%dotsToShow == minV){
        setTimeout(function(){
          reviFromLast = false;
          reverseProcess = true;
          $('.prev-arrow-btn').trigger('click');
        },500)
      }
    }
  }); 
});
